import { render, staticRenderFns } from "./AlignToolButton.vue?vue&type=template&id=a2a56a02"
import script from "./AlignToolButton.vue?vue&type=script&lang=js"
export * from "./AlignToolButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports